import { App } from '@capacitor/app';
import { NativeCalls } from 'src/app/plugins/native-runtime.plugins';
import { Injectable } from '@angular/core';
//import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { Conversation } from 'src/app/Models/Classes/Chat/conversation';
import { Message } from 'src/app/Models/Classes/Chat/message';
import * as models from 'src/app/Models/Classes/graphql/models/models-graphql';
import { UserContact } from 'src/app/Models/Classes/User/user-contact';
import { Utils } from 'src/app/Models/Classes/utils';
import { FriendshipService } from '../relations/relations.service';
import { GraphQLAPIService } from '../request/GraphQl-Api.service';
import { CameraServiceService } from '../multimedia/camera-service.service';
import { MediaItem } from 'src/app/Models/Classes/Media/media-item';
import { ForegroundService } from '@ionic-native/foreground-service/ngx';
import { promise } from 'selenium-webdriver';
import {CommentsService} from "../comments/comments.service";
import { ToastController } from '@ionic/angular';
import { RequestService } from 'src/app/services/request/request.service';
import Swal2 from 'sweetalert2';
import {Capacitor} from "@capacitor/core";
import { LocalNotifications as CapacitorLocalNotifications } from '@capacitor/local-notifications';
import { Howl } from 'howler';
import { ModalController } from '@ionic/angular';
import {ChimeContactComponent} from "src/app/chime-contact/meeting/chime-contact.component";
//import { Data } from 'phaser';
//import AWS from 'aws-sdk';
import {InlineBowsingComponent} from 'src/app/inline-bowsing/inline-bowsing.component';

@Injectable({
	providedIn: 'root'
})
export class ChatService {
		//chat tags start
		public main_actual_chat_tag: string = "normal";
		public main_available_chat_tags: Array<string> = ["archivados", "con llave", 'normal'];
		public main_icons_for_chat_tags: Array<string> = [ "archive-sharp", "finger-print-sharp", 'chatbox-outline'];
		//chat tags end
	locked_conversations: any[] = [];
	archived_conversations: any[] = [];
	soundTimeout;
	public sound: Howl;
	contentMessage;
	public Notificationuser_id: number= 0;
	public descriptionNotification: any= '';
	public isLogued: boolean = false;
	public index: number = 100;

	private isComplete: boolean = false;
	private timer: number = 100000; //100000
	public conversationsList: Array<Conversation> = new Array<Conversation>();
	/** Distinguishes an empty inbox from an inbox that is still being fetched. */
	public conversationsLoading = false;
	public conversationsLoadComplete = false;
	public conversationsLoadError = '';
	public contactList: Array<UserContact> = new Array<UserContact>();
	private listSubscriptions: Array<any> = new Array<any>();
	private nativeCallActive = false;
	public owner: UserContact;
	public conversationOpened: string;

	constructor(
		private Api: GraphQLAPIService,
		private utils: Utils,
		private localNotifications: LocalNotifications,
		//private backgroundMode: BackgroundMode,
		private friendshipService: FriendshipService,
		private cameraService: CameraServiceService,
		private foreground: ForegroundService,
	private commentService: CommentsService,
	private request: RequestService,
	private modalController: ModalController,
	//private platform: Platform,
	) {
        if (Capacitor.getPlatform() === 'ios' && Capacitor.isPluginAvailable('NativeCalls')) {
            const refreshNativeCalls = () => NativeCalls.getPending()
                .then(state => { this.nativeCallActive = state.calls.length > 0; }).catch(console.warn);
            void refreshNativeCalls();
            void App.addListener('appStateChange', state => {
                if (state.isActive) void refreshNativeCalls();
            });
            void NativeCalls.addListener('callEvent', event => {
                if (event.action === 'end') this.nativeCallActive = false;
                if (event.action === 'incoming' || event.action === 'answer') {
                    this.nativeCallActive = true;
                    this.stopAudio();
                    Swal2.close();
                }
            }).catch(console.warn);
        }
	}
	  async init(): Promise<void> {
		if (this.conversationsLoading) return;

		this.conversationsLoading = true;
		this.conversationsLoadComplete = false;
		this.conversationsLoadError = '';
		try {
			this.contactList = await this.getContactList();
			const profileData = await this.utils.getItem('ProfileData');
			const parsedProfile = typeof profileData === 'string' ? JSON.parse(profileData) : profileData;
			if (!parsedProfile) {
				this.conversationsList = [];
				return;
			}

			this.owner = new UserContact({ ...parsedProfile, owner: true });
			this.resetConnection();
			this.resetConnections();
			await this.buildService(this.owner);
			this.isComplete = true;
		} catch (error) {
			this.conversationsList = [];
			this.conversationsLoadError = 'No se pudieron cargar las conversaciones.';
			console.error('Unable to initialise conversations:', error);
		} finally {
			this.conversationsLoading = false;
			this.conversationsLoadComplete = true;
		}
	  }

	/** Re-fetches the GraphQL inbox without restarting the application shell. */
	  async refreshConversations(): Promise<void> {
		if (this.conversationsLoading) return;
		if (!this.owner) {
			await this.init();
			return;
		}

		this.conversationsLoading = true;
		this.conversationsLoadComplete = false;
		this.conversationsLoadError = '';
		try {
			await this.buildService(this.owner);
		} catch (error) {
			this.conversationsLoadError = 'No se pudieron actualizar las conversaciones.';
			console.error('Unable to refresh conversations:', error);
		} finally {
			this.conversationsLoading = false;
			this.conversationsLoadComplete = true;
		}
	  }

	/* ---------------------------- METODOS PARA VERIFICAR USARIOS CONECTADOS --------------------------------------------------------------------- */
	private resetConnection() {
		this.sendConnection()
		setInterval(() => {
			this.sendConnection()
		}, this.timer)
	}

	private resetConnections() {
		this.getIsUsersConnected();
		setInterval(() => {
			this.getIsUsersConnected();
		}, this.timer);
	}

	private getIsUsersConnected() {
		this.contactList.forEach(userContact => {
			let date = new Date();
			var diasdif = date.getTime() - userContact.getDateSince().getTime();
			if (diasdif > this.timer) {
				userContact.status = false;
			} else {
				userContact.status = true;
			}
		});
	}
	private sendConnection() {
		var input: models.CreateConnectionInput = {
			userID: this.owner?.id?.toString(),
			status: true
		}
		this.Api.CreateConnection(input).then((connectionResponse) => {
console.log('connectionResponse', connectionResponse);

		}).catch((error) => {
			console.error(error);
		})
	}
	/* ---------------------------- FIN METODOS PARA VERIFICAR USARIOS CONECTADOS --------------------------------------------------------------------- */



	/* ---------------------------- SUSCRIPCIONES PARA NUEVAS CONVERSACIONES QUE TE HAN AGREGADO DE FORMA MANUAL --------------------------------------------------------------------- */
	private startListenerNewUserConversation(owner: UserContact, conversationsList: Array<Conversation>): Promise<any> {
		return new Promise((resolve, reject) => {
			this.createUserConversationSubscriber(owner, conversationsList).then((newUserConversationSubscription) => {
				resolve(newUserConversationSubscription);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private createUserConversationSubscriber(owner: UserContact, conversationsList: Array<Conversation>): Promise<any> {
		return new Promise((resolve, reject) => {
			let conversationSubscription = this.Api.OnCreateUserConversationByUserListener(owner.id).subscribe((userConversationObserver: models.SubscriptionResponse<models.OnCreateUserConversationByUserSubscription>) => {
				this.checkUserConversationResponse(userConversationObserver).then((conversationResponse) => {
					this.getConversationFound(conversationResponse, owner, conversationsList).then((conversation) => {

					}).catch((error) => {
						reject(error);
					});
				}).catch((error) => {
					reject(error);
				});
			}, ((error) => {
				reject(error);
			}));
			resolve(conversationSubscription);
		});
	}
	private checkUserConversationResponse(userConversationObserver: models.SubscriptionResponse<models.OnCreateUserConversationByUserSubscription>): Promise<models.GetConversationQuery> {
		return new Promise((resolve, reject) => {
			if (userConversationObserver && userConversationObserver.value.data.onCreateUserConversationByUser.conversation) {
				resolve(userConversationObserver.value.data.onCreateUserConversationByUser.conversation);
			}
			reject(userConversationObserver);
		});
	}

	private getConversationFound(conversationResponse: models.GetConversationQuery, owner: UserContact, conversationsList: Array<Conversation>): Promise<Conversation> {
		return new Promise((resolve, reject) => {
			let conversationFound = conversationsList.find(conversationFound => (conversationFound.getID() == conversationResponse.id));
			if (conversationFound) {
			
				 resolve(conversationFound);
			} else {
				this.createConversation(conversationResponse, owner).then((conversation) => {
					console.log('conversationsList',this.conversationsList)
					this.conversationsList.push(conversation);
					resolve(conversation);
				}).catch((error) => {
					reject(error);
				});
			}
		});
	}
	/* ---------------------------- FIN SUSCRIPCIONES PARA NUEVAS CONVERSACIONES QUE TE HAN AGREGADO DE FORMA MANUAL ----------------------------------------------------------------- */


	/* SUSCRIPCIONES CUANDO AGREGAS A USUARIOS Y AVISARLE A TODOS QUE HAS AGREGADO A ALGUIEN */
	/* */


	/* ---------------------------- SUSCRIPCIONES PARA NUEVAS CONVERSACIONES -------------------------------------- */
	private startListenerNewConversations(owner: UserContact, conversationsList: Array<Conversation>): Promise<any> {
		return new Promise((resolve, reject) => {
			this.createNewConversationsSubscriber(owner, conversationsList).then((newConversationSubscriber) => {
				resolve(newConversationSubscriber);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private createNewConversationsSubscriber(owner, conversationsList): Promise<any> {
		return new Promise((resolve, reject) => {
			let conversationSubscription = this.Api.OnCreateConversationByUsersListListener.subscribe((conversationObserver: models.SubscriptionResponse<models.OnCreateConversationByUsersListSubscription>) => {

				this.checkConversationResponse(conversationObserver, owner).then((conversationResponse) => {
					this.getConversationFound(conversationResponse, owner, conversationsList).then((conversation) => {
						//resolve(conversation);
					}).catch((error) => {
						reject(error);
					});
				}).catch((error) => {
					reject(error);
				});
			}, ((error) => {
				reject(error);
			}));
			resolve(conversationSubscription);
		});
	}

	private checkConversationResponse(conversationObserver: models.SubscriptionResponse<models.OnCreateConversationByUsersListSubscription>, owner: UserContact): Promise<models.GetConversationQuery> {
		return new Promise((resolve, reject) => {
			if (conversationObserver && conversationObserver.value.data.onCreateConversationByUsersList) {
				if (!(conversationObserver.value.data.onCreateConversationByUsersList.userID == owner.id)) {
					let userFound = conversationObserver.value.data.onCreateConversationByUsersList.users.items.find(userItem => userItem.user.id == owner.id)
					if (userFound) {
						resolve(conversationObserver.value.data.onCreateConversationByUsersList);
					} else {
						reject(conversationObserver)
					}
				} else {
					reject(conversationObserver)
				}
			}
			reject(conversationObserver);
		});
	}
	/* ---------------------------- FIN SUSCRIPCIONES PARA NUEVAS CONVERSACIONES ---------------------------------- */



	/* ---------------------------- SUSCRIPCIONES PARA ACTUALIZAR CONVERSACIONES -------------------------------------- */
	private startListenerUpdateConversations(owner: UserContact, conversationsList: Array<Conversation>): Promise<any> {
		return new Promise((resolve, reject) => {
			let promises = [];
			conversationsList.forEach(conversation => {
				if (conversation.getIsGroup()) {
					promises.push(this.createUpdateConversationSubsriber(conversation, owner));
				}
			});
			Promise.all(promises).then((subscriberList) => {
				resolve(subscriberList);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private createUpdateConversationSubsriber(conversation: Conversation, owner: UserContact): Promise<any> {
		return new Promise((resolve, reject) => {
			let conversationSubscription = this.Api.OnUpdateConversationByConversationListener(conversation.getID()).subscribe((updateConversationSubscriber: models.SubscriptionResponse<models.OnUpdateConversationByConversationSubscription>) => {
				this.checkUpdateConversationListener(updateConversationSubscriber).then((updatedConversation) => {

				}).catch((error) => {
					console.error(error);
				});
			}, ((error) => {
				reject(error);
			}));
			resolve(conversationSubscription);
		});
	}

	private checkUpdateConversationListener(updateConversationSubscriber: models.SubscriptionResponse<models.OnUpdateConversationByConversationSubscription>): Promise<models.OnUpdateConversationByConversationSubscription> {
		return new Promise((resolve, reject) => {
			if (updateConversationSubscriber && updateConversationSubscriber.value.data.onUpdateConversationByConversation) {
				resolve(updateConversationSubscriber.value.data.onUpdateConversationByConversation)
			} else {
				reject(null);
			}
		});
	}
	/* ---------------------------- FIN SUSCRIPCIONES PARA ACTUALIZAR CONVERSACIONES ---------------------------------- */



	/* ---------------------------- SUSCRIPCIONES PARA NUEVAS CONEXIONES -------------------------------------- */
	private startListenerConnectionByUsers(cotactList: Array<UserContact>): Promise<any> {
		return new Promise((resolve, reject) => {
			let promises = [];
			cotactList.forEach(userContact => {
				promises.push(this.createConnectionByUserSubsriber(userContact));
			});
			Promise.all(promises).then((subscriberList) => {
				resolve(subscriberList);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private createConnectionByUserSubsriber(userContact: UserContact): Promise<any> {
		return new Promise((resolve, reject) => {
			let conversationSubscription = this.Api.OnCreateConnectionByUserListener(userContact.id).subscribe((connectionResponse: models.SubscriptionResponse<models.OnCreateConnectionByUserSubscription>) => {
				this.checkConnectionByUserListener(userContact, connectionResponse).then((createdAt: string) => {
					userContact.lastStatus = createdAt;
				}).catch((error) => {
					console.error(error);
				});
			}, ((error) => {
				reject(error);
			}));
			resolve(conversationSubscription);
		});
	}

	private checkConnectionByUserListener(userContact: UserContact, connectionResponse: models.SubscriptionResponse<models.OnCreateConnectionByUserSubscription>): Promise<string> {
		return new Promise((resolve, reject) => {
			userContact.status = connectionResponse.value.data.onCreateConnectionByUser.status;
			if (connectionResponse.value.data.onCreateConnectionByUser.status) {
				resolve(connectionResponse.value.data.onCreateConnectionByUser.createdAt);
			} else {
				reject(null);
			}
		});
	}
	/* ---------------------------- FIN SUSCRIPCIONES PARA NUEVAS CONEXIONES ---------------------------------- */



	/* ---------------------------- SUSCRIPCIONES PARA NUEVOS MENSAJES -------------------------------------------- */
	private startListenerNewMessages(owner: UserContact, conversationsList: Array<Conversation>): Promise<any> {
		return new Promise((resolve, reject) => {
			let promises = [];
			conversationsList.forEach(conversation => {
				promises.push(this.createMessageSubscriber(conversation, owner));
			});
			Promise.all(promises).then((subscriberList) => {
				resolve(subscriberList);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private createMessageSubscriber(conversation: Conversation, owner: UserContact): Promise<any> {
		return new Promise((resolve, reject) => {
			let subscriptionToMessages = this.Api.OnCreateMessageByConversationListener(conversation.getID()).subscribe((messageObserver: any) => {
				this.checkMessageByListener(owner, messageObserver.value.data.onCreateMessageByConversation).then((message) => {
					this.soundNotification(message, owner);
					
					if ( message.getUser().id != owner.id) { //this.backgroundMode.isActive() && 
						this.scheduleIncomingMessageNotification(conversation, message);
						 this.contentMessage=message;
					
					}
					conversation.addMessage(message);
					conversation.setNewLastMessage(message);
					this.orderChatList(this.conversationsList);
					if (!message.getIsMine(this.owner.id)) {
						conversation.addMessageToUnread(message);
						if (this.conversationOpened && this.conversationOpened === conversation.getID()) {
							this.updateSeenMessages(conversation).then((data) => {
								conversation.clearUnreadMessages();
							}).catch((error) => {
								console.error(error);
							});
						}
					}
				}).catch((error) => {
					reject(error);
				});
			}, (error) => {
				reject(error);
			});
			resolve(subscriptionToMessages);
		});
	}
	async openBrowser(url: string) {
		//await Browser.open({ url });
		const modal = await this.modalController.create({
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)
			component: InlineBowsingComponent,
			componentProps: {
				url: url,
			
			},
		  });
		  modal.onDidDismiss().then((data)=>{
			
		  });
		  return await modal.present();
		window.open(url, '_blank'); // Open the URL in a new tab or window
	  }

	private checkMessageByListener(owner: UserContact, messageObserver: models.GetMessageQuery): Promise<Message> {
		return new Promise((resolve, reject) => {
			if (owner && messageObserver) {
				let newMessage = new Message(messageObserver);
				resolve(newMessage);
			}
			reject("Mensaje inválido");
		});
	}
	/* ---------------------------- FIN SUSCRIPCIONES PARA NUEVOS MENSAJES ---------------------------------------- */

	stopAudio() {
		if (this.sound) {
		  this.sound.stop();
		}
	}

	/* ---------------------------- SUSCRIPCIONES PARA NUEVOS MENSAJES LEIDOS-------------------------------------------- */
	private startListenerNewMessagesSeen(owner: UserContact, conversationsList: Array<Conversation>): Promise<any> {
		return new Promise((resolve, reject) => {
			let promises = [];
			conversationsList.forEach(conversation => {
				promises.push(this.createMessageSeenSubscriber(conversation, owner));
			});
			Promise.all(promises).then((subscriberList) => {
				resolve(subscriberList);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private createMessageSeenSubscriber(conversation: Conversation, owner: UserContact): Promise<any> {
		return new Promise((resolve, reject) => {
			let subscriptionToMessagesSeen = this.Api.OnCreateSeenByConversationListener(conversation.getID()).subscribe((seenResponse: models.SubscriptionResponse<models.OnCreateSeenByConversationSubscription>) => {
				this.checkMessageSeenByListener(owner, seenResponse.value.data.onCreateSeenByConversation).then((parsendSeenResponse) => {
					parsendSeenResponse.messages.items.forEach((item) => {
						let messageFound = conversation.getMessagesList().find(message => (message.getId() == item.message.id));
						if (messageFound) {
							messageFound.clearUsers(item.message.users);
							messageFound.setSeen(conversation.getUsers());
						}
					});
				}).catch((error) => {
					reject(error);
				});
			}, (error) => {
				reject(error);
			});
			resolve(subscriptionToMessagesSeen);
		});
	}

	private checkMessageSeenByListener(owner: UserContact, seenResponse: models.OnCreateSeenByConversationSubscription): Promise<models.OnCreateSeenByConversationSubscription> {
		return new Promise((resolve, reject) => {
			if (owner && seenResponse) {
				resolve(seenResponse);
			}
			reject(null);
		});
	}
	/* ---------------------------- FIN SUSCRIPCIONES PARA NUEVOS MENSAJES LEIDOS ---------------------------------------- */



	/* ---------------------------- SUSCRIPCIONES PARA ELIMINAR MENSAJES -------------------------------------------- */
	private startListenerUpdateMessages(owner: UserContact, conversationsList: Array<Conversation>): Promise<any> {
		return new Promise((resolve, reject) => {
			let promises = [];
			conversationsList.forEach(conversation => {
				promises.push(this.updateMessageSubscriber(conversation, owner));
			});
			Promise.all(promises).then((subscriberList) => {
				this.listSubscriptions = this.listSubscriptions.concat(subscriberList);
				resolve(subscriberList);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private updateMessageSubscriber(conversation: Conversation, owner: UserContact): Promise<any> {
		return new Promise((resolve, reject) => {
			let subscriptionToMessages = this.Api.OnUpdateMessageByConversationListener(conversation.getID()).subscribe((messageObserver: any) => {
				this.checkUpdateMessageByListener(owner, conversation, messageObserver.value.data.onUpdateMessageByConversation).then((message) => {
					this.soundNotification(message, owner);
					
					// Message updates (seen/edited state) must not create a second notification.
				}).catch((error) => {
					reject(error);
				});
			}, (error) => {
				reject(error);
			});
			resolve(subscriptionToMessages);
		});
	}

	private checkUpdateMessageByListener(owner: UserContact, conversation: Conversation, messageObserver: models.GetMessageQuery): Promise<Message> {
		return new Promise((resolve, reject) => {
			if (owner && messageObserver) {
				let message = conversation.getMessagesList().find(message => (message.getId() == messageObserver.id))
				if (message) {
					message.setText(messageObserver.body);
					message.setDelete(messageObserver.isDelete);

					let messagesFound: Array<Message>;
					try {
						messagesFound = conversation.getMessagesList().filter((messageAux: Message) => ((messageAux.getMessageResponse() && messageAux.getMessageResponse().getId()) == message.getId()));
					} catch (e) {
						console.log(e);
						reject(e);
					}

					if (messagesFound) {

						messagesFound.forEach((messageFound) => {
							messageFound.getMessageResponse().setText(messageObserver.body);
							messageFound.getMessageResponse().setDelete(messageObserver.isDelete);
						});
						resolve(message);
					} else {

						resolve(message);
					}
				} else {
					reject("Mensaje inválido");
				}
			}
			reject("Mensaje inválido");
		});
	}
	/* ---------------------------- FIN SUSCRIPCIONES PARA ELIMINAR MENSAJES ---------------------------------------- */



	/* ---------------------------- CREAR UNA LISTA DE CONVERSACIONES DEL USUARIO --------------------------------- */
	private startChatService(owner: UserContact): Promise<any> {
		return new Promise((resolve, reject) => {
			this.getConversations(owner).then(conversationsByUser => {
				resolve(conversationsByUser);
			}).catch(error => {
				reject(error);
			});
		});
	}

	private getConversations(owner: UserContact): Promise<any> {
		return new Promise((resolve, reject) => {
			this.Api.GetConversationsByUser(owner.id).then((userResponse: models.GetUserQuery) => {
				if (userResponse) {
					this.buildConversations(userResponse, owner).then((response) => {
						resolve(response);
					}).catch((error) => {
						console.error(error);
					});
				} else {
					reject(userResponse);
				}
			}).catch(error => {
				reject(error);
			});

		});
	}

	private buildConversations(userResponse: models.GetUserQuery, owner: UserContact): Promise<any> {
		return new Promise((resolve, reject) => {
			let conversationsList = [];
			userResponse.conversations.items.forEach((conversationResponse: models.GetConversationQuery) => {
				conversationsList.push(this.createConversation(conversationResponse.conversation, owner));
			});
			Promise.all(conversationsList).then((conversationsList) => {
				resolve(conversationsList);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private createConversation(conversationResponse: models.GetConversationQuery, owner: UserContact): Promise<Conversation> {
		return new Promise((resolve, reject) => {
			if (conversationResponse && owner) {
				let conversation = new Conversation(conversationResponse, owner, this.contactList);
				this.getMessagesByConversation(conversation, 30, conversation.getNextToken()).then(() => {
					conversation.setNotificationID(this.index);
					this.index++;
					let promises = []

					promises.push(this.createMessageSubscriber(conversation, owner));
					promises.push(this.createMessageSeenSubscriber(conversation, owner));
					promises.push(this.updateMessageSubscriber(conversation, owner));
					promises.push(this.createUpdateConversationSubsriber(conversation, owner));

					Promise.all(promises).then((subscriptionsList) => {
						this.listSubscriptions = this.listSubscriptions.concat(subscriptionsList);
						resolve(conversation);
					}).catch((error) => {
						reject(error);
					});
				}).catch((error) => {
					reject(error);
				});
			} else {
				reject(null);
			}
		});
	}
	/* ---------------------------- FIN CREAR UNA LISTA DE CONVERSACIONES DEL USUARIO ------------------------------ */



	/* ---------------------------- FUNCIONES ESCENCIALES ---------------------------------------------------------- */
	public async buildService(owner: UserContact): Promise<any[]> {
		const conversationList = await this.startChatService(owner) || [];
		let response: any;
		try {
			response = await this.request.createRequestPost('getConversationTagsForAuthenticatedUser', {});
			if (typeof response === 'string') response = JSON.parse(response);
		} catch (error) {
			// Conversations are still usable when tag metadata is temporarily unavailable.
			console.error('Unable to load conversation tags:', error);
		}

		const taggedConversations = Array.isArray(response?.success) ? response.success : [];
		if (this.main_actual_chat_tag === 'con llave') {
			this.locked_conversations = taggedConversations.filter((conversation: any) => conversation.type === 'con llave');
			this.archived_conversations = [];
			const ids = new Set(this.locked_conversations.map((conversation: any) => conversation.conversation_id));
			this.conversationsList = conversationList.filter((conversation: any) => ids.has(conversation.id));
		} else if (this.main_actual_chat_tag === 'archivados') {
			this.archived_conversations = taggedConversations.filter((conversation: any) => conversation.tag === 'archivados');
			this.locked_conversations = [];
			const ids = new Set(this.archived_conversations.map((conversation: any) => conversation.conversation_id));
			this.conversationsList = conversationList.filter((conversation: any) => ids.has(conversation.id));
		} else {
			this.locked_conversations = [];
			this.archived_conversations = [];
			const ids = new Set(taggedConversations
				.filter((conversation: any) => conversation.tag !== null)
				.map((conversation: any) => conversation.conversation_id));
			this.conversationsList = conversationList.filter((conversation: any) => !ids.has(conversation.id));
		}

		this.orderChatList(this.conversationsList);
		if (this.isLogued) return [];

		const listenersList = await Promise.all([
			this.startListenerConnectionByUsers(this.contactList),
			this.startListenerNewUserConversation(owner, this.conversationsList),
			this.startListenerNewConversations(owner, this.conversationsList),
		]);
		this.listSubscriptions = this.listSubscriptions.concat(listenersList);
		this.isLogued = true;
		return listenersList;
	}

	public logoutSuscribers() {
		this.foreground.stop();
		this.listSubscriptions.forEach(subscriber => {
			subscriber.unsubscribe();
		});
		this.isLogued = false;
		this.conversationsList = new Array<Conversation>();
		this.listSubscriptions = new Array<any>();
	}

	private soundNotification(message: Message, owner: UserContact) {
		if (message.getUser().id != owner.id) {
			const audioFile = 'assets/sounds/receive_sound.wav';
			const sound = new Howl({
			  src: [audioFile],
			  autoplay: true,
			  volume: 1.0, // Initial volume level (0.0 to 1.0)
			});
			sound.play();
		}
	}
	/* ---------------------------- FIN FUNCIONES ESCENCIALES ------------------------------------------------------ */



	/* ---------------------------- LISTA DE MENSAJES -------------------------------------------------------------- */
	public async getContactList(): Promise<Array<UserContact>> {
		if (Capacitor.getPlatform() === 'ios') {
			return new Promise((resolve, reject) => {
				this.getFriends().then((relations) => {
					const promises = relations.map((relation) =>
						this.addFriendsToContactList(relation).catch(() => null),
					);
					Promise.all(promises).then((contactList) => {
						resolve(contactList.filter((contact): contact is UserContact => contact !== null));
					}).catch(reject);
				}).catch(reject);
			});
		}

		return new Promise(async (resolve, reject) => {
			try {
				const relations = await this.getFriends();
				const contactList = await Promise.all(relations.map((relation) =>
					this.addFriendsToContactList(relation).catch(() => null),
				));
				resolve(contactList.filter((contact): contact is UserContact => contact !== null));
			} catch (error) {
				console.error('Error while fetching contact list:', error);
				reject(error);
			}
		});
	}

	private addFriendsToContactList(relation: any): Promise<UserContact | null> {
		const entries = Array.isArray(relation) ? relation : [relation];
		const friendRelation = entries.find((entry: any) =>
			entry?.relationType === 'Amigo' || entry?.buttons_info?.friendsButton?.text === 'Amigos'
		) || entries[0];
		const friend = friendRelation?.user_info || friendRelation?.user || friendRelation;
		if (!friend?.profile_id) return Promise.resolve(null);

		return this.Api.GetUser(String(friend.profile_id)).then((userResponse: models.GetUserQuery) => {
			if (!userResponse) throw new Error('User response not found');
			friend.lastConnection = userResponse.connections?.items?.length
				? userResponse.connections.items[0].createdAt
				: null;
			const contact = new UserContact(friend);
			if (Capacitor.getPlatform() !== 'ios') this.contactList.push(contact);
			return contact;
		});
	}
	

	private getFriends(): Promise<any> {
	
		if (Capacitor.getPlatform() === 'ios') {
		return new Promise((resolve, reject) => {
			let relationType = [1, 2];
			let relationDirection = 3;
			let relationStatus = 2;

			let request = {
				'relationDirection': relationDirection.toString(),  // 1 Envio, 2 Recibido, 3 Todos
				'relationType': relationType,   // 1 Amigo, 2 S Amigos, 3 Seguidores
				'relationStatus': relationStatus.toString()  // 1 Pendiente, 2 Confirmado
			};

			this.friendshipService.getAllRelations(request).then((relations) => {
				resolve(this.normaliseFriendRelations(relations));
			
			}).catch((error) => {
				reject(error);
			});
		});
	}else{
		return new Promise((resolve, reject) => {
			let relationType = [1, 2];
			let relationDirection = 3;
			let relationStatus = 2;

			let request = {
				'relationDirection': relationDirection,  // 1 Envio, 2 Recibido, 3 Todos
				'relationType': relationType,   // 1 Amigo, 2 S Amigos, 3 Seguidores
				'relationStatus': relationStatus  // 1 Pendiente, 2 Confirmado
			};

			this.friendshipService.getAllRelations(request).then((relations) => {
				resolve(this.normaliseFriendRelations(relations));
			}).catch((error) => {
				reject(error);
			});
		});
		}
	}

	private normaliseFriendRelations(raw: any): any[] {
		let data = raw;
		if (typeof data === 'string') {
			try { data = JSON.parse(data); } catch { return []; }
		}
		return Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
	}

	

	public getMessagesByConversation(conversation: Conversation, limit: number, nextToken: string): Promise<any> {
		return new Promise((resolve, reject) => {
			if (!(nextToken === null) || nextToken === undefined) {
				this.Api.GetConversationMessages(conversation.getID(), limit, nextToken).then((conversationResponse: models.GetConversationQuery) => {
					conversation.setNextToken(conversationResponse.messages.nextToken);
					conversationResponse.messages.items.forEach(messageResponse => {
						let messageTemp = new Message(messageResponse)
						messageTemp.setSeen(conversation.getUsers());
						console.log('chat user_id',conversation.getUsers() );
						if (!messageTemp.getSeen() && !messageTemp.getIsMine(this.owner.id)) {
							conversation.addMessageToUnread(messageTemp);
						}
						conversation.addMessageTop(messageTemp);
					});
					resolve(true);
				}).catch(error => {
					reject(error);
				});
			}
		});
	}

	public sendMessage(conversation: Conversation, newMessage: Message, messageResponse?: Message): Promise<models.CreateMessageMutation> {
		return new Promise((resolve, reject) => {
      console.log('new message have multimedia', newMessage.getHaveMultimedia());
			if (!this.IsEmptyText(newMessage.getText()) || newMessage.getHaveMultimedia()) {
				let newMessageReq: models.CreateMessageInput = {
					userID: this.owner.id,
					conversationID: conversation.getID(),
					isDelete: false,
					isSeen: false,
					isSystemNotification: false,
					body: newMessage.getText()
				};
				if (messageResponse) {
					newMessageReq.messageID = messageResponse.getId();
				}
        //se reusa la variable blobsMultimediacomment ya que ahi se guarda la multimedia en tex-input-component
				if (this.commentService.blobsMultimediaComment.length>0) {
          this.commentService.blobsMultimediaComment.forEach(media => {
            console.log('media item in chat service', media);
						this.cameraService.postMultimediaForChat(media, "mensaje").then((data: any) => {
							data = JSON.parse(data);
							newMessageReq.multimediaID = data.chatElement.id;
							this.sendMessageOnGraphQl(newMessageReq).then((messageResponse) => {
								this.notifyMessageRecipients(conversation, newMessage);
								resolve(messageResponse);
							}).catch((error) => {
								console.error(error);
								reject(error);
							});
						}).catch((error) => {
							console.error(error);

							reject(error);
						});
					});
				}
				else {

					this.sendMessageOnGraphQl(newMessageReq).then((messageResponse) => {
						this.notifyMessageRecipients(conversation, newMessage);
						resolve(messageResponse);
					}).catch((error) => {
						console.error(error);

						reject(error);
					});
				}
			}
		});
	}

	public updateMessage(message: Message, messageID?:any, text?:any, ): Promise<models.CreateMessageMutation> {
		return new Promise((resolve, reject) => {
			let updateMessageReq: models.UpdateMessageInput ;
			if(messageID){
				 updateMessageReq= {
					id: messageID,
					isDelete: true,
					body: "Mensaje Eliminado"
				}
			}else{
				 updateMessageReq = {
					id: message.getId(),
					isDelete: true,
					body: "Mensaje Eliminado"
				}
			}
			
			
			this.updateMessageOnGraphQl(updateMessageReq).then((messageResponse) => {
				resolve(messageResponse);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	/** Update a structured chat card (for example, a poll vote) without deleting it. */
	public updateMessageBody(messageId: string, body: string): Promise<models.CreateMessageMutation> {
		return this.updateMessageOnGraphQl({ id: messageId, body, isDelete: false });
	}

	private resendMessage(conversation: Conversation, message: Message) {
		return new Promise((resolve, reject) => {
			this.sendMessage(conversation, message).then((message) => {
				resolve(message);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	public resendMessageByConversation(conversationList: Array<UserContact | Conversation>, message: Message) {
		return new Promise((resolve, reject) => {
			let promises = new Array<Promise<any>>();

			conversationList.forEach((conversation: Conversation) => {
				promises.push(this.resendMessage(conversation, message));
			});

			Promise.all(promises).then((messagesList) => {
				resolve(messagesList);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	public sendMessageOnGraphQl(newMessageReq: models.CreateMessageInput): Promise<models.CreateMessageMutation> {
		return new Promise((resolve, reject) => {
			this.Api.CreateMessage(newMessageReq).then(messageResponse => {
				console.log(messageResponse);
				resolve(messageResponse);
			}).catch(error => {
				reject(error);
			}).finally(() => {
				const audioFile = 'assets/sounds/send_sound.wav';
			const sound = new Howl({
			  src: [audioFile],
			  autoplay: true,
			  volume: 1.0, // Initial volume level (0.0 to 1.0)
			});
			sound.play();
			});
		})
	}

	private updateMessageOnGraphQl(newMessageReq: models.UpdateMessageInput): Promise<models.CreateMessageMutation> {
		return new Promise((resolve, reject) => {
			this.Api.UpdateMessage(newMessageReq).then(messageResponse => {
				resolve(messageResponse);
			}).catch(error => {
				reject(error);
			}).finally(() => {
				const sound = new Howl({
					src: ['assets/sounds/send_sound.wav'],
					volume: 1.0,
				});
				sound.play();
			});
		})
	}

	private IsEmptyText(textInput: string) {
		textInput = textInput.replace(/[\r\n\s]+/gm, "");
		if (textInput.length > 0) {
			return false;
		}
		else {
			return true;
		}
	}
	/* ---------------------------- FIN LISTA DE MENSAJES ---------------------------------------------------------- */



	/* ---------------------------- NUEVAS CONVERSACIONES ---------------------------------------------------------- */
	private async ensureConversationOwner(): Promise<UserContact> {
		if (this.owner?.id) return this.owner;

		const storedProfile = await this.utils.getItem('ProfileData');
		const profile = typeof storedProfile === 'string' ? JSON.parse(storedProfile) : storedProfile;
		if (!profile?.id) {
			throw new Error('Sign in to Laniakea before opening a direct message.');
		}

		// Chat GraphQL users are created with profiles.id during login and registration.
		this.owner = new UserContact({ ...profile, owner: true });
		return this.owner;
	}

	public newConversation(userRelation: UserContact): Promise<Conversation> {
		return new Promise(async (resolve, reject) => {
			let owner: UserContact;
			try {
				owner = await this.ensureConversationOwner();
				await this.ensureChatUser(userRelation);
				this.cacheContact(userRelation);
			} catch (error) {
				reject(error);
				return;
			}

			let usersList = []
			usersList.push({ "userID": owner.id, "isDelete": false, "isAdmin": true });
			usersList.push({ "userID": userRelation.id, "isDelete": false, "isAdmin": false });

			this.Api.GetUserConversationsByUsers(usersList[0].userID, usersList[1].userID).then((userResponse: models.GetUserConversationsByUsersQuery) => { //Usuario -> Lista de conversaciones
				this.checkConversationOnServer(userResponse).then((conversationExist: models.GetConversationQuery) => {
					this.getConversationFound(conversationExist, owner, this.conversationsList).then((conversation: Conversation) => {
						resolve(conversation);
					}).catch((error) => {
						reject(error)
					});
				}).catch(() => {
					let conversationRequest: models.CreateConversationByUsersList = {
						usersList: usersList,
						isGroup: false,
						isDelete: false,
						name: 'Conversación privada'//userRelation.name
					}
					this.createNewConversation(conversationRequest).then((conversationResponse: any) => {
						this.createConversation(conversationResponse, owner).then((conversation) => {
							this.conversationsList.push(conversation);
							resolve(conversation);
						}).catch((error) => {
							reject(error);
						});
					}).catch((error) => {
						reject(error);
					});
				});
			}).catch(error => {
				reject(error);
			});
		});
	}

	/**
	 * Older accounts can be friends in the main API but have no corresponding
	 * record in the legacy GraphQL chat store. A private conversation cannot be
	 * created until that record exists, so provision it lazily and safely.
	 */
	private async ensureChatUser(contact: UserContact): Promise<void> {
		if (!contact?.id) {
			throw new Error('The selected contact does not have a profile identifier.');
		}

		const id = String(contact.id);
		try {
			const existing = await this.Api.GetUser(id);
			if (existing) return;
		} catch (lookupError) {
			// A missing GraphQL record is returned as either null or a rejected
			// query depending on the deployed resolver version. The create below
			// is idempotent; genuine authorization/network errors still surface.
			console.warn('Chat user lookup did not return a record; provisioning it.', lookupError);
		}

		try {
			await this.Api.CreateUser({
				id,
				username: contact.username || `user_${id}`,
			});
		} catch (createError) {
			// Another client may have initialized the record in the gap between
			// lookup and create. Re-check once before treating it as a failure.
			const existing = await this.Api.GetUser(id).catch(() => null);
			if (!existing) throw createError;
		}
	}

	private cacheContact(contact: UserContact): void {
		const index = this.contactList.findIndex((item) => String(item.id) === String(contact.id));
		if (index >= 0) this.contactList[index] = contact;
		else this.contactList.push(contact);
	}

	public newGroupConversation(usersRelation: Array<UserContact>, chatName: string): Promise<Conversation> {
		return new Promise((resolve, reject) => {
			let usersList = [];
			usersList.push({ "userID": this.owner.id, "isDelete": false, "isAdmin": true });
			usersRelation.forEach(user => {
				usersList.push({ "userID": user.id, "isDelete": false, "isAdmin": false });
			});
			let conversationRequest: models.CreateConversationByUsersList = {
				usersList: usersList,
				isGroup: true,
				isDelete: false,
				name: chatName//userRelation.name
			}
			this.createNewConversation(conversationRequest).then((conversationResponse: any) => {
				this.createConversation(conversationResponse, this.owner).then((conversation) => {
					this.conversationsList.push(conversation);
					resolve(conversation);
				}).catch((error) => {
					reject(error);
				});
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private checkConversationOnServer(userResponse: models.GetUserConversationsByUsersQuery): Promise<models.GetConversationQuery> {
		return new Promise((resolve, reject) => {
			if (userResponse && userResponse.conversations) {
				let conversationResponse = userResponse.conversations.items.find(conversationItem => (conversationItem.conversation.users.items.length > 0 && !conversationItem.conversation.isGroup));
				if (conversationResponse) {
					resolve(conversationResponse.conversation);
				} else {
					reject(userResponse);
				}
			} else {
				reject(userResponse);
			}
		});
	}

	private createNewConversation(conversationRequest: models.CreateConversationByUsersList): Promise<models.CreateConversationByUsersListMutation> {
		return new Promise((resolve, reject) => {
			this.Api.CreateConversationByUsersList(conversationRequest, conversationRequest.usersList[0].userID).then((conversation: models.CreateConversationByUsersListMutation) => {

				resolve(conversation);
			}).catch((error) => {
				reject(error);
			});
		});

	}
	/* ---------------------------- FIN NUEVAS CONVERSACIONES ------------------------------------------------------- */



	/* ---------------------------- ACTUALIZAR CONVERSACIONES ------------------------------------------------------- */
	public uploadChatImagen(mediaItem: MediaItem, conversation: Conversation): Promise<any> {
		return new Promise((resolve, reject) => {
			this.cameraService.postMultimediaForChat(mediaItem, "Conversación", conversation.getID()).then((chatElementResponse: string) => {
				let chatResponseObject = JSON.parse(chatElementResponse);
				let promises = [];
				let newMesssageReq: models.CreateMessageInput = {
					userID: this.owner.id,
					conversationID: conversation.getID(),
					isSeen: false,
					body: "Cambió la imagen del grupo",
					isSystemNotification: true,
					isDelete: false,
				}
				promises.push(this.sendMessageOnGraphQl(newMesssageReq));
				promises.push(this.updateConversationInfo(conversation, chatResponseObject.chatElement.id));
				Promise.all(promises).then(() => {
					resolve(chatResponseObject);
				}).catch((error) => {
					reject(error);
				});
			}).catch((error) => {
				reject(error);
			});
		});
	}

	public updateConversationName(conversation: Conversation): Promise<any> {
		return new Promise((resolve, reject) => {
			let promises = [];
			let newMessageReq: models.CreateMessageInput = {
				userID: this.owner.id,
				isDelete: false,
				isSeen: false,
				isSystemNotification: true,
				conversationID: conversation.getID(),
				body: "Cambió el nombre de la conversación"
			}
			promises.push(this.sendMessageOnGraphQl(newMessageReq));
			promises.push(this.updateConversationInfo(conversation));
			Promise.all(promises).then((promisesArray) => {
				resolve(promisesArray);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private updateConversationInfo(conversation: Conversation, chatResponseObjectID?: string): Promise<models.GetConversationQuery> {
		return new Promise((resolve, reject) => {
			let conversationInput: models.UpdateConversationInput = {
				id: conversation.getID(),
				name: conversation.getName(),
				isGroup: true,
				isDelete: false,
				multimediaID: (chatResponseObjectID) ? chatResponseObjectID : null
			}
			this.Api.UpdateConversation(conversationInput).then((conversation: models.GetConversationQuery) => {
				resolve(conversation);
			}).catch((error) => {
				reject(error);
			});
		});
	}
	/* ---------------------------- FIN ACTUALIZAR CONVERSACIONES ------------------------------------------------------- */


	public findUserInChatService(user: UserContact): Promise<models.GetUserQuery> {
		return new Promise((resolve, reject) => {
			this.Api.GetUser(user.id).then((userResponse: models.GetUserQuery) => {
				resolve(userResponse);
			}).catch((error) => {
				reject(error);
			})
		});
	}

	public updateSeenMessages(conversation: Conversation): Promise<any> {
		return new Promise((resolve, reject) => {
			let input: models.CreateUserMessageByMessagesList = {
				userID: this.owner.id,
				conversationID: conversation.getID(),
				isDelete: false,
				messages: []
			}
			this.pushUnreadMessages(conversation).then((messagesUnread) => {
				if (messagesUnread && messagesUnread.length > 0) {
					input.messages = messagesUnread;
					this.Api.CreateSeenByMessages(input).then((messagesSeen: models.CreateSeenByMessagesMutation) => {

						conversation.clearUnreadMessages();
					}).catch((error) => {
						console.error(error);
					});

				} else {

				}
			}).catch((error) => {
				console.error(error);
			});
		});
	}

	public pushUnreadMessages(conversation: Conversation): Promise<Array<models.CreateMessageIdInput>> {
		return new Promise((resolve, reject) => {
			let promises = [];
			conversation.getUnreadMessages().forEach((message: Message) => {
				promises.push(this.createMessageUnread(message));
			});
			Promise.all(promises).then((messagesUnread) => {
				resolve(messagesUnread);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	public createMessageUnread(message): Promise<models.CreateMessageIdInput> {
		return new Promise((resolve, reject) => {
			let messageId: models.CreateMessageIdInput = {
				messageID: message.getId()
			}
			resolve(messageId);
		});
	}


	public orderChatList(chatList: Array<Conversation>) {
		chatList = chatList.sort((p1, p2) => {
			let firstDate = (p1.getLastMessage()) ? p1.getLastMessage().getDate() : p1.getDate();
			let secondDate = (p2.getLastMessage()) ? p2.getLastMessage().getDate() : p2.getDate();
			return (firstDate > secondDate) ? -1 : 1;
		});
	}
	private async scheduleIncomingMessageNotification(conversation: Conversation, message: Message): Promise<void> {
		if (Capacitor.getPlatform() === 'web') {
			return;
		}

		const sender = message.getUser();
		const senderName = sender?.username ? `@${sender.username}` : 'Laniakea';
		const body = message.getText() || 'Te envió un archivo multimedia.';
		const notificationId = Math.floor(Date.now() % 2147483647);

		try {
			let permission = await CapacitorLocalNotifications.checkPermissions();
			if (permission.display === 'prompt' || permission.display === 'prompt-with-rationale') {
				permission = await CapacitorLocalNotifications.requestPermissions();
			}
			if (permission.display !== 'granted') {
				console.warn('Local notifications permission was not granted:', permission.display);
				return;
			}

			await CapacitorLocalNotifications.schedule({
			notifications: [{
				title: `Nuevo mensaje de ${senderName}`,
				body,
				id: notificationId,
				schedule: { at: new Date(Date.now() + 250) },
				sound: null,
				attachments: null,
				actionTypeId: '',
				extra: { conversation_id: conversation.getID() },
				channelId: null,
			}],
			});
		} catch (error) {
			console.error('Failed to schedule incoming-message notification:', error);
		}
	}

	private notifyMessageRecipients(conversation: Conversation, message: Message): void {
		const senderName = this.owner?.username ? `@${this.owner.username}` : 'Laniakea';
		const body = this.notificationPreview(
			message.getText() || 'Te envió un archivo multimedia.',
		);
		const recipientIds = new Set(
			(conversation.getUsers() || [])
				.map((user) => Number(user?.id || 0))
				.filter((userId) => userId > 0 && userId !== Number(this.owner?.id)),
		);

		recipientIds.forEach((recipientId) => {
			this.sendNotification(
				recipientId,
				body,
				`Nuevo mensaje de ${senderName}`,
				conversation.getID(),
			)
				.catch((error) => console.error('Failed to send message push notification:', error));
		});
	}

	/** Keep FCM/APNs payloads comfortably below their 4 KB hard limit. */
	private notificationPreview(value: unknown, maximumCharacters: number = 180): string {
		const normalized = String(value || '')
			.replace(/\s+/gu, ' ')
			.trim();
		const characters = Array.from(normalized);
		return characters.length > maximumCharacters
			? `${characters.slice(0, maximumCharacters - 1).join('')}…`
			: normalized;
	}

	sendNotification(user, body, title: string = 'Nuevo MD', conversationId?: string) {
		const recipientProfileId = Number(user);
		if (!Number.isInteger(recipientProfileId) || recipientProfileId <= 0) {
			return Promise.reject(new Error('A direct-message recipient profile ID is required.'));
		}

		return new Promise((resolve, reject) => {
		  const notification = {
			title: title,
			body: this.notificationPreview(body),
			// Chat identities are profile IDs. Laravel resolves the corresponding
			// RDS users row from users.profile_id for every notification.
			profile_id: recipientProfileId,
			conversation_id: conversationId ? String(conversationId) : undefined,
			universal_link: conversationId
				? `https://laniakea.tv/home/chat-page/${encodeURIComponent(String(conversationId))}`
				: undefined,
			interaction_type: 'direct_message',
			destination_type: 'whisper_conversation',
			delivery_mode: 'push_only',
			push_only: true,
		  };
	  
		  this.request.createRequestPost('GreatAtractorNotifications', notification)
			.then((data) => {
			  const response = typeof data === 'string' ? JSON.parse(data) : data;
			  if (response?.success === false) {
				throw new Error(response?.error || 'Firebase did not accept the notification');
			  }
			  console.log('Message push notification accepted:', response);
			  resolve(data);
			}).catch((error) => {
			  console.error('Failed to send notification:', error);
			  reject(error);
			});
		});
	  }

}
